// extracted by mini-css-extract-plugin
module.exports = {"container":"_1_l79C5_9Bg7ZspbgxYWRn","visible":"_3Cu2AIiYcWOEwOPiHOKw_M","heading":"dd83Ni9O4PeMGiVlB4GH6"};